module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_40.3af2fe6c.png";